import {
  FormControl,
  FormHelperText,
  InputBase,
  InputBaseProps,
  InputLabel,
  Typography,
  styled,
} from '@mui/material'
import { Control, Controller } from 'react-hook-form'
import { NumericFormat } from 'react-number-format'

const CustomInput = styled(InputBase)(({ theme }) => ({
  border: '1px solid #d9d9d9',
  padding: '5px 15px',
  fontWeight: 'bold',
  borderRadius: 5,
  boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.1)',
  backgroundColor: theme.palette.background.paper,
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '.MuiInputAdornment-root': {
    color: '#000',
  },
}))

type InputProps = {
  name: string
  label: string
  control: Control<any>
} & InputBaseProps

const FormInput = (props: InputProps) => {
  const { name, control, label, ...rest } = props

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl variant="standard">
          <InputLabel htmlFor={name} shrink>
            <Typography
              color="black"
              variant="h5"
              fontWeight={700}
              fontSize={{
                md: '18px !important',
                xs: '16px !important',
              }}
            >
              {label}
            </Typography>
          </InputLabel>
          {rest.type === 'number' ? (
            <NumericFormat
              value={field.value}
              disabled={field.disabled}
              onBlur={field.onBlur}
              error={!!error}
              id={name}
              name={name}
              autoFocus
              startAdornment={rest.startAdornment}
              thousandSeparator={true}
              customInput={CustomInput}
              aria-label={label}
              onValueChange={({ floatValue }) => {
                field.onChange(floatValue !== undefined ? floatValue : '')
              }}
            />
          ) : (
            <CustomInput
              {...field}
              error={!!error}
              id={name}
              name={name}
              autoFocus
              aria-label={label}
              {...rest}
            />
          )}
          {!!error && (
            <FormHelperText error id={`${name}-helper`}>
              <Typography variant="body2" fontWeight={700}>
                {error.message}
              </Typography>
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  )
}

export default FormInput
